// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { frontmatter as fm0, toc as t0 } from '/opt/buildhome/repo/packages/x/.dumi/pages/index/common/CustomizationProvider.tsx?type=frontmatter';
import { frontmatter as fm1, toc as t1 } from '/opt/buildhome/repo/packages/x/.dumi/pages/index/common/CustomizationSender.tsx?type=frontmatter';
import { frontmatter as fm2, toc as t2 } from '/opt/buildhome/repo/packages/x/.dumi/pages/index/common/Introduction.tsx?type=frontmatter';
import { frontmatter as fm3, toc as t3 } from '/opt/buildhome/repo/packages/x/.dumi/pages/index/common/Container.tsx?type=frontmatter';
import { frontmatter as fm4, toc as t4 } from '/opt/buildhome/repo/packages/x/.dumi/pages/index-cn/index.ts?type=frontmatter';
import { frontmatter as fm5, toc as t5 } from '/opt/buildhome/repo/packages/x/.dumi/pages/index/index.tsx?type=frontmatter';
import { frontmatter as fm6, toc as t6 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/default-chat-provider-width-ui.md?type=frontmatter';
import { demoIndex as dmi6 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/default-chat-provider-width-ui.md?type=demo-index';
import { frontmatter as fm7, toc as t7 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/custom-provider-width-ui.md?type=frontmatter';
import { demoIndex as dmi7 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/custom-provider-width-ui.md?type=demo-index';
import { frontmatter as fm8, toc as t8 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/deep-seek-chat-provider.md?type=frontmatter';
import { demoIndex as dmi8 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/deep-seek-chat-provider.md?type=demo-index';
import { frontmatter as fm9, toc as t9 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/async-defaultMessages.md?type=frontmatter';
import { demoIndex as dmi9 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/async-defaultMessages.md?type=demo-index';
import { frontmatter as fm10, toc as t10 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/default-chat-provider.md?type=frontmatter';
import { demoIndex as dmi10 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/default-chat-provider.md?type=demo-index';
import { frontmatter as fm11, toc as t11 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/open-ai-chat-provider.md?type=frontmatter';
import { demoIndex as dmi11 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/open-ai-chat-provider.md?type=demo-index';
import { frontmatter as fm12, toc as t12 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/multi-instances.md?type=frontmatter';
import { demoIndex as dmi12 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/multi-instances.md?type=demo-index';
import { frontmatter as fm13, toc as t13 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-params-headers.md?type=frontmatter';
import { demoIndex as dmi13 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-params-headers.md?type=demo-index';
import { frontmatter as fm14, toc as t14 } from '/opt/buildhome/repo/packages/x/docs/spec/provide-intention-expectation.en-US.md?type=frontmatter';
import { demoIndex as dmi14 } from '/opt/buildhome/repo/packages/x/docs/spec/provide-intention-expectation.en-US.md?type=demo-index';
import { frontmatter as fm15, toc as t15 } from '/opt/buildhome/repo/packages/x/docs/spec/provide-intention-expectation.zh-CN.md?type=frontmatter';
import { demoIndex as dmi15 } from '/opt/buildhome/repo/packages/x/docs/spec/provide-intention-expectation.zh-CN.md?type=demo-index';
import { frontmatter as fm16, toc as t16 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/async-defaultMessages.md?type=frontmatter';
import { demoIndex as dmi16 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/async-defaultMessages.md?type=demo-index';
import { frontmatter as fm17, toc as t17 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-transformer.md?type=frontmatter';
import { demoIndex as dmi17 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-transformer.md?type=demo-index';
import { frontmatter as fm18, toc as t18 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/custom-request-fetch.md?type=frontmatter';
import { demoIndex as dmi18 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/custom-request-fetch.md?type=demo-index';
import { frontmatter as fm19, toc as t19 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/session-key.md?type=frontmatter';
import { demoIndex as dmi19 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/session-key.md?type=demo-index';
import { frontmatter as fm20, toc as t20 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/with-x-chat.md?type=frontmatter';
import { demoIndex as dmi20 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/with-x-chat.md?type=demo-index';
import { frontmatter as fm21, toc as t21 } from '/opt/buildhome/repo/packages/x/docs/spec/feedback-result-application.en-US.md?type=frontmatter';
import { demoIndex as dmi21 } from '/opt/buildhome/repo/packages/x/docs/spec/feedback-result-application.en-US.md?type=demo-index';
import { frontmatter as fm22, toc as t22 } from '/opt/buildhome/repo/packages/x/docs/spec/feedback-result-application.zh-CN.md?type=frontmatter';
import { demoIndex as dmi22 } from '/opt/buildhome/repo/packages/x/docs/spec/feedback-result-application.zh-CN.md?type=demo-index';
import { frontmatter as fm23, toc as t23 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/request-openai-node.md?type=frontmatter';
import { demoIndex as dmi23 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/request-openai-node.md?type=demo-index';
import { frontmatter as fm24, toc as t24 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/operations.md?type=frontmatter';
import { demoIndex as dmi24 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/operations.md?type=demo-index';
import { frontmatter as fm25, toc as t25 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/stream-separator.md?type=frontmatter';
import { demoIndex as dmi25 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/stream-separator.md?type=demo-index';
import { frontmatter as fm26, toc as t26 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-create-react-app.en-US.md?type=frontmatter';
import { demoIndex as dmi26 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-create-react-app.en-US.md?type=demo-index';
import { frontmatter as fm27, toc as t27 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-create-react-app.zh-CN.md?type=frontmatter';
import { demoIndex as dmi27 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-create-react-app.zh-CN.md?type=demo-index';
import { frontmatter as fm28, toc as t28 } from '/opt/buildhome/repo/packages/x/docs/spec/confirm-generation-process.en-US.md?type=frontmatter';
import { demoIndex as dmi28 } from '/opt/buildhome/repo/packages/x/docs/spec/confirm-generation-process.en-US.md?type=demo-index';
import { frontmatter as fm29, toc as t29 } from '/opt/buildhome/repo/packages/x/docs/spec/confirm-generation-process.zh-CN.md?type=frontmatter';
import { demoIndex as dmi29 } from '/opt/buildhome/repo/packages/x/docs/spec/confirm-generation-process.zh-CN.md?type=demo-index';
import { frontmatter as fm30, toc as t30 } from '/opt/buildhome/repo/packages/x/docs/spec/guide-intention-expression.en-US.md?type=frontmatter';
import { demoIndex as dmi30 } from '/opt/buildhome/repo/packages/x/docs/spec/guide-intention-expression.en-US.md?type=demo-index';
import { frontmatter as fm31, toc as t31 } from '/opt/buildhome/repo/packages/x/docs/spec/guide-intention-expression.zh-CN.md?type=frontmatter';
import { demoIndex as dmi31 } from '/opt/buildhome/repo/packages/x/docs/spec/guide-intention-expression.zh-CN.md?type=demo-index';
import { frontmatter as fm32, toc as t32 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-stream/default-protocol.md?type=frontmatter';
import { demoIndex as dmi32 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-stream/default-protocol.md?type=demo-index';
import { frontmatter as fm33, toc as t33 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/stream-timeout.md?type=frontmatter';
import { demoIndex as dmi33 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/stream-timeout.md?type=demo-index';
import { frontmatter as fm34, toc as t34 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-stream/custom-protocol.md?type=frontmatter';
import { demoIndex as dmi34 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-stream/custom-protocol.md?type=demo-index';
import { frontmatter as fm35, toc as t35 } from '/opt/buildhome/repo/packages/x/docs/spec/feedback-result-display.en-US.md?type=frontmatter';
import { demoIndex as dmi35 } from '/opt/buildhome/repo/packages/x/docs/spec/feedback-result-display.en-US.md?type=demo-index';
import { frontmatter as fm36, toc as t36 } from '/opt/buildhome/repo/packages/x/docs/spec/feedback-result-display.zh-CN.md?type=frontmatter';
import { demoIndex as dmi36 } from '/opt/buildhome/repo/packages/x/docs/spec/feedback-result-display.zh-CN.md?type=demo-index';
import { frontmatter as fm37, toc as t37 } from '/opt/buildhome/repo/packages/x/docs/spec/wake-up-welcome-message.en-US.md?type=frontmatter';
import { demoIndex as dmi37 } from '/opt/buildhome/repo/packages/x/docs/spec/wake-up-welcome-message.en-US.md?type=demo-index';
import { frontmatter as fm38, toc as t38 } from '/opt/buildhome/repo/packages/x/docs/spec/wake-up-welcome-message.zh-CN.md?type=frontmatter';
import { demoIndex as dmi38 } from '/opt/buildhome/repo/packages/x/docs/spec/wake-up-welcome-message.zh-CN.md?type=demo-index';
import { frontmatter as fm39, toc as t39 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-deepseek.en-US.md?type=frontmatter';
import { demoIndex as dmi39 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-deepseek.en-US.md?type=demo-index';
import { frontmatter as fm40, toc as t40 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-deepseek.zh-CN.md?type=frontmatter';
import { demoIndex as dmi40 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-deepseek.zh-CN.md?type=demo-index';
import { frontmatter as fm41, toc as t41 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/defaultMessages.md?type=frontmatter';
import { demoIndex as dmi41 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/defaultMessages.md?type=demo-index';
import { frontmatter as fm42, toc as t42 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/openai-callback.md?type=frontmatter';
import { demoIndex as dmi42 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/openai-callback.md?type=demo-index';
import { frontmatter as fm43, toc as t43 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.en-US.md?type=frontmatter';
import { demoIndex as dmi43 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.en-US.md?type=demo-index';
import { frontmatter as fm44, toc as t44 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.zh-CN.md?type=frontmatter';
import { demoIndex as dmi44 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.zh-CN.md?type=demo-index';
import { frontmatter as fm45, toc as t45 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.en-US.md?type=frontmatter';
import { demoIndex as dmi45 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.en-US.md?type=demo-index';
import { frontmatter as fm46, toc as t46 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.zh-CN.md?type=frontmatter';
import { demoIndex as dmi46 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.zh-CN.md?type=demo-index';
import { frontmatter as fm47, toc as t47 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/basic.md?type=frontmatter';
import { demoIndex as dmi47 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/basic.md?type=demo-index';
import { frontmatter as fm48, toc as t48 } from '/opt/buildhome/repo/packages/x/docs/spec/define-intention-type.en-US.md?type=frontmatter';
import { demoIndex as dmi48 } from '/opt/buildhome/repo/packages/x/docs/spec/define-intention-type.en-US.md?type=demo-index';
import { frontmatter as fm49, toc as t49 } from '/opt/buildhome/repo/packages/x/docs/spec/define-intention-type.zh-CN.md?type=frontmatter';
import { demoIndex as dmi49 } from '/opt/buildhome/repo/packages/x/docs/spec/define-intention-type.zh-CN.md?type=demo-index';
import { frontmatter as fm50, toc as t50 } from '/opt/buildhome/repo/packages/x/docs/spec/expression-user-input.en-US.md?type=frontmatter';
import { demoIndex as dmi50 } from '/opt/buildhome/repo/packages/x/docs/spec/expression-user-input.en-US.md?type=demo-index';
import { frontmatter as fm51, toc as t51 } from '/opt/buildhome/repo/packages/x/docs/spec/expression-user-input.zh-CN.md?type=frontmatter';
import { demoIndex as dmi51 } from '/opt/buildhome/repo/packages/x/docs/spec/expression-user-input.zh-CN.md?type=demo-index';
import { frontmatter as fm52, toc as t52 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.en-US.md?type=frontmatter';
import { demoIndex as dmi52 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.en-US.md?type=demo-index';
import { frontmatter as fm53, toc as t53 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.zh-CN.md?type=frontmatter';
import { demoIndex as dmi53 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.zh-CN.md?type=demo-index';
import { frontmatter as fm54, toc as t54 } from '/opt/buildhome/repo/packages/x/docs/spec/authentic-consistent.en-US.md?type=frontmatter';
import { demoIndex as dmi54 } from '/opt/buildhome/repo/packages/x/docs/spec/authentic-consistent.en-US.md?type=demo-index';
import { frontmatter as fm55, toc as t55 } from '/opt/buildhome/repo/packages/x/docs/spec/authentic-consistent.zh-CN.md?type=frontmatter';
import { demoIndex as dmi55 } from '/opt/buildhome/repo/packages/x/docs/spec/authentic-consistent.zh-CN.md?type=demo-index';
import { frontmatter as fm56, toc as t56 } from '/opt/buildhome/repo/packages/x/docs/spec/expression-user-send.en-US.md?type=frontmatter';
import { demoIndex as dmi56 } from '/opt/buildhome/repo/packages/x/docs/spec/expression-user-send.en-US.md?type=demo-index';
import { frontmatter as fm57, toc as t57 } from '/opt/buildhome/repo/packages/x/docs/spec/expression-user-send.zh-CN.md?type=frontmatter';
import { demoIndex as dmi57 } from '/opt/buildhome/repo/packages/x/docs/spec/expression-user-send.zh-CN.md?type=demo-index';
import { frontmatter as fm58, toc as t58 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-conversations.en-US.md?type=frontmatter';
import { demoIndex as dmi58 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-conversations.en-US.md?type=demo-index';
import { frontmatter as fm59, toc as t59 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-conversations.zh-CN.md?type=frontmatter';
import { demoIndex as dmi59 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-conversations.zh-CN.md?type=demo-index';
import { frontmatter as fm60, toc as t60 } from '/opt/buildhome/repo/packages/x/docs/spec/conversation-design.en-US.md?type=frontmatter';
import { demoIndex as dmi60 } from '/opt/buildhome/repo/packages/x/docs/spec/conversation-design.en-US.md?type=demo-index';
import { frontmatter as fm61, toc as t61 } from '/opt/buildhome/repo/packages/x/docs/spec/conversation-design.zh-CN.md?type=frontmatter';
import { demoIndex as dmi61 } from '/opt/buildhome/repo/packages/x/docs/spec/conversation-design.zh-CN.md?type=demo-index';
import { frontmatter as fm62, toc as t62 } from '/opt/buildhome/repo/packages/x/docs/spec/intention-introduce.en-US.md?type=frontmatter';
import { demoIndex as dmi62 } from '/opt/buildhome/repo/packages/x/docs/spec/intention-introduce.en-US.md?type=demo-index';
import { frontmatter as fm63, toc as t63 } from '/opt/buildhome/repo/packages/x/docs/spec/intention-introduce.zh-CN.md?type=frontmatter';
import { demoIndex as dmi63 } from '/opt/buildhome/repo/packages/x/docs/spec/intention-introduce.zh-CN.md?type=demo-index';
import { frontmatter as fm64, toc as t64 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.en-US.md?type=frontmatter';
import { demoIndex as dmi64 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.en-US.md?type=demo-index';
import { frontmatter as fm65, toc as t65 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.zh-CN.md?type=frontmatter';
import { demoIndex as dmi65 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.zh-CN.md?type=demo-index';
import { frontmatter as fm66, toc as t66 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.en-US.md?type=frontmatter';
import { demoIndex as dmi66 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.en-US.md?type=demo-index';
import { frontmatter as fm67, toc as t67 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.zh-CN.md?type=frontmatter';
import { demoIndex as dmi67 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.zh-CN.md?type=demo-index';
import { frontmatter as fm68, toc as t68 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.en-US.md?type=frontmatter';
import { demoIndex as dmi68 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.en-US.md?type=demo-index';
import { frontmatter as fm69, toc as t69 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.zh-CN.md?type=frontmatter';
import { demoIndex as dmi69 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.zh-CN.md?type=demo-index';
import { frontmatter as fm70, toc as t70 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/timeout.md?type=frontmatter';
import { demoIndex as dmi70 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/timeout.md?type=demo-index';
import { frontmatter as fm71, toc as t71 } from '/opt/buildhome/repo/packages/x/docs/playground/independent.en-US.md?type=frontmatter';
import { demoIndex as dmi71 } from '/opt/buildhome/repo/packages/x/docs/playground/independent.en-US.md?type=demo-index';
import { frontmatter as fm72, toc as t72 } from '/opt/buildhome/repo/packages/x/docs/playground/independent.zh-CN.md?type=frontmatter';
import { demoIndex as dmi72 } from '/opt/buildhome/repo/packages/x/docs/playground/independent.zh-CN.md?type=demo-index';
import { frontmatter as fm73, toc as t73 } from '/opt/buildhome/repo/packages/x/docs/playground/ultramodern.en-US.md?type=frontmatter';
import { demoIndex as dmi73 } from '/opt/buildhome/repo/packages/x/docs/playground/ultramodern.en-US.md?type=demo-index';
import { frontmatter as fm74, toc as t74 } from '/opt/buildhome/repo/packages/x/docs/playground/ultramodern.zh-CN.md?type=frontmatter';
import { demoIndex as dmi74 } from '/opt/buildhome/repo/packages/x/docs/playground/ultramodern.zh-CN.md?type=demo-index';
import { frontmatter as fm75, toc as t75 } from '/opt/buildhome/repo/packages/x/docs/react/compatible-style.en-US.md?type=frontmatter';
import { demoIndex as dmi75 } from '/opt/buildhome/repo/packages/x/docs/react/compatible-style.en-US.md?type=demo-index';
import { frontmatter as fm76, toc as t76 } from '/opt/buildhome/repo/packages/x/docs/react/compatible-style.zh-CN.md?type=frontmatter';
import { demoIndex as dmi76 } from '/opt/buildhome/repo/packages/x/docs/react/compatible-style.zh-CN.md?type=demo-index';
import { frontmatter as fm77, toc as t77 } from '/opt/buildhome/repo/packages/x/docs/react/model-use-openai.en-US.md?type=frontmatter';
import { demoIndex as dmi77 } from '/opt/buildhome/repo/packages/x/docs/react/model-use-openai.en-US.md?type=demo-index';
import { frontmatter as fm78, toc as t78 } from '/opt/buildhome/repo/packages/x/docs/react/model-use-openai.zh-CN.md?type=frontmatter';
import { demoIndex as dmi78 } from '/opt/buildhome/repo/packages/x/docs/react/model-use-openai.zh-CN.md?type=demo-index';
import { frontmatter as fm79, toc as t79 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-rsbuild.en-US.md?type=frontmatter';
import { demoIndex as dmi79 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-rsbuild.en-US.md?type=demo-index';
import { frontmatter as fm80, toc as t80 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-rsbuild.zh-CN.md?type=frontmatter';
import { demoIndex as dmi80 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-rsbuild.zh-CN.md?type=demo-index';
import { frontmatter as fm81, toc as t81 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/developer.md?type=frontmatter';
import { demoIndex as dmi81 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/developer.md?type=demo-index';
import { frontmatter as fm82, toc as t82 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/manual.md?type=frontmatter';
import { demoIndex as dmi82 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/manual.md?type=demo-index';
import { frontmatter as fm83, toc as t83 } from '/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.en-US.md?type=frontmatter';
import { demoIndex as dmi83 } from '/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.en-US.md?type=demo-index';
import { frontmatter as fm84, toc as t84 } from '/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.zh-CN.md?type=frontmatter';
import { demoIndex as dmi84 } from '/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.zh-CN.md?type=demo-index';
import { frontmatter as fm85, toc as t85 } from '/opt/buildhome/repo/packages/x/docs/spec/hybrid-ui-design.en-US.md?type=frontmatter';
import { demoIndex as dmi85 } from '/opt/buildhome/repo/packages/x/docs/spec/hybrid-ui-design.en-US.md?type=demo-index';
import { frontmatter as fm86, toc as t86 } from '/opt/buildhome/repo/packages/x/docs/spec/hybrid-ui-design.zh-CN.md?type=frontmatter';
import { demoIndex as dmi86 } from '/opt/buildhome/repo/packages/x/docs/spec/hybrid-ui-design.zh-CN.md?type=demo-index';
import { frontmatter as fm87, toc as t87 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/components.en-US.md?type=frontmatter';
import { demoIndex as dmi87 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/components.en-US.md?type=demo-index';
import { frontmatter as fm88, toc as t88 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/components.zh-CN.md?type=frontmatter';
import { demoIndex as dmi88 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/components.zh-CN.md?type=demo-index';
import { frontmatter as fm89, toc as t89 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/playground.en-US.md?type=frontmatter';
import { demoIndex as dmi89 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/playground.en-US.md?type=demo-index';
import { frontmatter as fm90, toc as t90 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/playground.zh-CN.md?type=frontmatter';
import { demoIndex as dmi90 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/playground.zh-CN.md?type=demo-index';
import { frontmatter as fm91, toc as t91 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/deepSeek.md?type=frontmatter';
import { demoIndex as dmi91 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/deepSeek.md?type=demo-index';
import { frontmatter as fm92, toc as t92 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/basic.md?type=frontmatter';
import { demoIndex as dmi92 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/basic.md?type=demo-index';
import { frontmatter as fm93, toc as t93 } from '/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.en-US.md?type=frontmatter';
import { demoIndex as dmi93 } from '/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.en-US.md?type=demo-index';
import { frontmatter as fm94, toc as t94 } from '/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.zh-CN.md?type=frontmatter';
import { demoIndex as dmi94 } from '/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.zh-CN.md?type=demo-index';
import { frontmatter as fm95, toc as t95 } from '/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.en-US.md?type=frontmatter';
import { demoIndex as dmi95 } from '/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.en-US.md?type=demo-index';
import { frontmatter as fm96, toc as t96 } from '/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.zh-CN.md?type=frontmatter';
import { demoIndex as dmi96 } from '/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.zh-CN.md?type=demo-index';
import { frontmatter as fm97, toc as t97 } from '/opt/buildhome/repo/packages/x/docs/spec/wake-up-ai-icon.en-US.md?type=frontmatter';
import { demoIndex as dmi97 } from '/opt/buildhome/repo/packages/x/docs/spec/wake-up-ai-icon.en-US.md?type=demo-index';
import { frontmatter as fm98, toc as t98 } from '/opt/buildhome/repo/packages/x/docs/spec/wake-up-ai-icon.zh-CN.md?type=frontmatter';
import { demoIndex as dmi98 } from '/opt/buildhome/repo/packages/x/docs/spec/wake-up-ai-icon.zh-CN.md?type=demo-index';
import { frontmatter as fm99, toc as t99 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/introduce.en-US.md?type=frontmatter';
import { demoIndex as dmi99 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/introduce.en-US.md?type=demo-index';
import { frontmatter as fm100, toc as t100 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/introduce.zh-CN.md?type=frontmatter';
import { demoIndex as dmi100 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/introduce.zh-CN.md?type=demo-index';
import { frontmatter as fm101, toc as t101 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.en-US.md?type=frontmatter';
import { demoIndex as dmi101 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.en-US.md?type=demo-index';
import { frontmatter as fm102, toc as t102 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.zh-CN.md?type=frontmatter';
import { demoIndex as dmi102 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.zh-CN.md?type=demo-index';
import { frontmatter as fm103, toc as t103 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.en-US.md?type=frontmatter';
import { demoIndex as dmi103 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.en-US.md?type=demo-index';
import { frontmatter as fm104, toc as t104 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.zh-CN.md?type=frontmatter';
import { demoIndex as dmi104 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.zh-CN.md?type=demo-index';
import { frontmatter as fm105, toc as t105 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-next.en-US.md?type=frontmatter';
import { demoIndex as dmi105 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-next.en-US.md?type=demo-index';
import { frontmatter as fm106, toc as t106 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-next.zh-CN.md?type=frontmatter';
import { demoIndex as dmi106 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-next.zh-CN.md?type=demo-index';
import { frontmatter as fm107, toc as t107 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-vite.en-US.md?type=frontmatter';
import { demoIndex as dmi107 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-vite.en-US.md?type=demo-index';
import { frontmatter as fm108, toc as t108 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-vite.zh-CN.md?type=frontmatter';
import { demoIndex as dmi108 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-vite.zh-CN.md?type=demo-index';
import { frontmatter as fm109, toc as t109 } from '/opt/buildhome/repo/packages/x/docs/spec/smooth-natural.en-US.md?type=frontmatter';
import { demoIndex as dmi109 } from '/opt/buildhome/repo/packages/x/docs/spec/smooth-natural.en-US.md?type=demo-index';
import { frontmatter as fm110, toc as t110 } from '/opt/buildhome/repo/packages/x/docs/spec/smooth-natural.zh-CN.md?type=frontmatter';
import { demoIndex as dmi110 } from '/opt/buildhome/repo/packages/x/docs/spec/smooth-natural.zh-CN.md?type=demo-index';
import { frontmatter as fm111, toc as t111 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/examples.en-US.md?type=frontmatter';
import { demoIndex as dmi111 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/examples.en-US.md?type=demo-index';
import { frontmatter as fm112, toc as t112 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/examples.zh-CN.md?type=frontmatter';
import { demoIndex as dmi112 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/examples.zh-CN.md?type=demo-index';
import { frontmatter as fm113, toc as t113 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.en-US.md?type=frontmatter';
import { demoIndex as dmi113 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.en-US.md?type=demo-index';
import { frontmatter as fm114, toc as t114 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.zh-CN.md?type=frontmatter';
import { demoIndex as dmi114 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.zh-CN.md?type=demo-index';
import { frontmatter as fm115, toc as t115 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/openai.md?type=frontmatter';
import { demoIndex as dmi115 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/openai.md?type=demo-index';
import { frontmatter as fm116, toc as t116 } from '/opt/buildhome/repo/packages/x/docs/playground/copilot.en-US.md?type=frontmatter';
import { demoIndex as dmi116 } from '/opt/buildhome/repo/packages/x/docs/playground/copilot.en-US.md?type=demo-index';
import { frontmatter as fm117, toc as t117 } from '/opt/buildhome/repo/packages/x/docs/playground/copilot.zh-CN.md?type=frontmatter';
import { demoIndex as dmi117 } from '/opt/buildhome/repo/packages/x/docs/playground/copilot.zh-CN.md?type=demo-index';
import { frontmatter as fm118, toc as t118 } from '/opt/buildhome/repo/packages/x/docs/react/common-props.en-US.md?type=frontmatter';
import { demoIndex as dmi118 } from '/opt/buildhome/repo/packages/x/docs/react/common-props.en-US.md?type=demo-index';
import { frontmatter as fm119, toc as t119 } from '/opt/buildhome/repo/packages/x/docs/react/common-props.zh-CN.md?type=frontmatter';
import { demoIndex as dmi119 } from '/opt/buildhome/repo/packages/x/docs/react/common-props.zh-CN.md?type=demo-index';
import { frontmatter as fm120, toc as t120 } from '/opt/buildhome/repo/packages/x/docs/react/contributing.en-US.md?type=frontmatter';
import { demoIndex as dmi120 } from '/opt/buildhome/repo/packages/x/docs/react/contributing.en-US.md?type=demo-index';
import { frontmatter as fm121, toc as t121 } from '/opt/buildhome/repo/packages/x/docs/react/contributing.zh-CN.md?type=frontmatter';
import { demoIndex as dmi121 } from '/opt/buildhome/repo/packages/x/docs/react/contributing.zh-CN.md?type=demo-index';
import { frontmatter as fm122, toc as t122 } from '/opt/buildhome/repo/packages/x/docs/react/migration-v2.en-US.md?type=frontmatter';
import { demoIndex as dmi122 } from '/opt/buildhome/repo/packages/x/docs/react/migration-v2.en-US.md?type=demo-index';
import { frontmatter as fm123, toc as t123 } from '/opt/buildhome/repo/packages/x/docs/react/migration-v2.zh-CN.md?type=frontmatter';
import { demoIndex as dmi123 } from '/opt/buildhome/repo/packages/x/docs/react/migration-v2.zh-CN.md?type=demo-index';
import { frontmatter as fm124, toc as t124 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-umi.en-US.md?type=frontmatter';
import { demoIndex as dmi124 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-umi.en-US.md?type=demo-index';
import { frontmatter as fm125, toc as t125 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-umi.zh-CN.md?type=frontmatter';
import { demoIndex as dmi125 } from '/opt/buildhome/repo/packages/x/docs/react/use-with-umi.zh-CN.md?type=demo-index';
import { frontmatter as fm126, toc as t126 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/plugins.en-US.md?type=frontmatter';
import { demoIndex as dmi126 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/plugins.en-US.md?type=demo-index';
import { frontmatter as fm127, toc as t127 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/plugins.zh-CN.md?type=frontmatter';
import { demoIndex as dmi127 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/plugins.zh-CN.md?type=demo-index';
import { frontmatter as fm128, toc as t128 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/themes.en-US.md?type=frontmatter';
import { demoIndex as dmi128 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/themes.en-US.md?type=demo-index';
import { frontmatter as fm129, toc as t129 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/themes.zh-CN.md?type=frontmatter';
import { demoIndex as dmi129 } from '/opt/buildhome/repo/packages/x/docs/x-markdown/themes.zh-CN.md?type=demo-index';
import { frontmatter as fm130, toc as t130 } from '/opt/buildhome/repo/packages/x/docs/x-skill/introduce.en-US.md?type=frontmatter';
import { demoIndex as dmi130 } from '/opt/buildhome/repo/packages/x/docs/x-skill/introduce.en-US.md?type=demo-index';
import { frontmatter as fm131, toc as t131 } from '/opt/buildhome/repo/packages/x/docs/x-skill/introduce.zh-CN.md?type=frontmatter';
import { demoIndex as dmi131 } from '/opt/buildhome/repo/packages/x/docs/x-skill/introduce.zh-CN.md?type=demo-index';
import { frontmatter as fm132, toc as t132 } from '/opt/buildhome/repo/packages/x/docs/spec/human-touch.en-US.md?type=frontmatter';
import { demoIndex as dmi132 } from '/opt/buildhome/repo/packages/x/docs/spec/human-touch.en-US.md?type=demo-index';
import { frontmatter as fm133, toc as t133 } from '/opt/buildhome/repo/packages/x/docs/spec/human-touch.zh-CN.md?type=frontmatter';
import { demoIndex as dmi133 } from '/opt/buildhome/repo/packages/x/docs/spec/human-touch.zh-CN.md?type=demo-index';
import { frontmatter as fm134, toc as t134 } from '/opt/buildhome/repo/packages/x/docs/spec/role-design.en-US.md?type=frontmatter';
import { demoIndex as dmi134 } from '/opt/buildhome/repo/packages/x/docs/spec/role-design.en-US.md?type=demo-index';
import { frontmatter as fm135, toc as t135 } from '/opt/buildhome/repo/packages/x/docs/spec/role-design.zh-CN.md?type=frontmatter';
import { demoIndex as dmi135 } from '/opt/buildhome/repo/packages/x/docs/spec/role-design.zh-CN.md?type=demo-index';
import { frontmatter as fm136, toc as t136 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.en-US.md?type=frontmatter';
import { demoIndex as dmi136 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.en-US.md?type=demo-index';
import { frontmatter as fm137, toc as t137 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.zh-CN.md?type=frontmatter';
import { demoIndex as dmi137 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.zh-CN.md?type=demo-index';
import { frontmatter as fm138, toc as t138 } from '/opt/buildhome/repo/packages/x/docs/react/introduce.en-US.md?type=frontmatter';
import { demoIndex as dmi138 } from '/opt/buildhome/repo/packages/x/docs/react/introduce.en-US.md?type=demo-index';
import { frontmatter as fm139, toc as t139 } from '/opt/buildhome/repo/packages/x/docs/react/introduce.zh-CN.md?type=frontmatter';
import { demoIndex as dmi139 } from '/opt/buildhome/repo/packages/x/docs/react/introduce.zh-CN.md?type=demo-index';
import { frontmatter as fm140, toc as t140 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/introduce.en-US.md?type=frontmatter';
import { demoIndex as dmi140 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/introduce.en-US.md?type=demo-index';
import { frontmatter as fm141, toc as t141 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/introduce.zh-CN.md?type=frontmatter';
import { demoIndex as dmi141 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/introduce.zh-CN.md?type=demo-index';
import { frontmatter as fm142, toc as t142 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.en-US.md?type=frontmatter';
import { demoIndex as dmi142 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.en-US.md?type=demo-index';
import { frontmatter as fm143, toc as t143 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.zh-CN.md?type=frontmatter';
import { demoIndex as dmi143 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.zh-CN.md?type=demo-index';
import { frontmatter as fm144, toc as t144 } from '/opt/buildhome/repo/packages/x/docs/spec/follow-up.en-US.md?type=frontmatter';
import { demoIndex as dmi144 } from '/opt/buildhome/repo/packages/x/docs/spec/follow-up.en-US.md?type=demo-index';
import { frontmatter as fm145, toc as t145 } from '/opt/buildhome/repo/packages/x/docs/spec/follow-up.zh-CN.md?type=frontmatter';
import { demoIndex as dmi145 } from '/opt/buildhome/repo/packages/x/docs/spec/follow-up.zh-CN.md?type=demo-index';
import { frontmatter as fm146, toc as t146 } from '/opt/buildhome/repo/packages/x/docs/spec/introduce.en-US.md?type=frontmatter';
import { demoIndex as dmi146 } from '/opt/buildhome/repo/packages/x/docs/spec/introduce.en-US.md?type=demo-index';
import { frontmatter as fm147, toc as t147 } from '/opt/buildhome/repo/packages/x/docs/spec/introduce.zh-CN.md?type=frontmatter';
import { demoIndex as dmi147 } from '/opt/buildhome/repo/packages/x/docs/spec/introduce.zh-CN.md?type=demo-index';
import { frontmatter as fm148, toc as t148 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.en-US.md?type=frontmatter';
import { demoIndex as dmi148 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.en-US.md?type=demo-index';
import { frontmatter as fm149, toc as t149 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.zh-CN.md?type=frontmatter';
import { demoIndex as dmi149 } from '/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.zh-CN.md?type=demo-index';
import { frontmatter as fm150, toc as t150 } from '/opt/buildhome/repo/packages/x/docs/x-skill/prompt.en-US.md?type=frontmatter';
import { demoIndex as dmi150 } from '/opt/buildhome/repo/packages/x/docs/x-skill/prompt.en-US.md?type=demo-index';
import { frontmatter as fm151, toc as t151 } from '/opt/buildhome/repo/packages/x/docs/x-skill/prompt.zh-CN.md?type=frontmatter';
import { demoIndex as dmi151 } from '/opt/buildhome/repo/packages/x/docs/x-skill/prompt.zh-CN.md?type=demo-index';
import { frontmatter as fm152, toc as t152 } from '/opt/buildhome/repo/packages/x/docs/x-skill/skills.en-US.md?type=frontmatter';
import { demoIndex as dmi152 } from '/opt/buildhome/repo/packages/x/docs/x-skill/skills.en-US.md?type=demo-index';
import { frontmatter as fm153, toc as t153 } from '/opt/buildhome/repo/packages/x/docs/x-skill/skills.zh-CN.md?type=frontmatter';
import { demoIndex as dmi153 } from '/opt/buildhome/repo/packages/x/docs/x-skill/skills.zh-CN.md?type=demo-index';
import { frontmatter as fm154, toc as t154 } from '/opt/buildhome/repo/packages/x/docs/spec/confirm.en-US.md?type=frontmatter';
import { demoIndex as dmi154 } from '/opt/buildhome/repo/packages/x/docs/spec/confirm.en-US.md?type=demo-index';
import { frontmatter as fm155, toc as t155 } from '/opt/buildhome/repo/packages/x/docs/spec/confirm.zh-CN.md?type=frontmatter';
import { demoIndex as dmi155 } from '/opt/buildhome/repo/packages/x/docs/spec/confirm.zh-CN.md?type=demo-index';
import { frontmatter as fm156, toc as t156 } from '/opt/buildhome/repo/packages/x/docs/spec/error.en-US.md?type=frontmatter';
import { demoIndex as dmi156 } from '/opt/buildhome/repo/packages/x/docs/spec/error.en-US.md?type=demo-index';
import { frontmatter as fm157, toc as t157 } from '/opt/buildhome/repo/packages/x/docs/spec/error.zh-CN.md?type=frontmatter';
import { demoIndex as dmi157 } from '/opt/buildhome/repo/packages/x/docs/spec/error.zh-CN.md?type=demo-index';
import { frontmatter as fm158, toc as t158 } from '/opt/buildhome/repo/packages/x/docs/spec/start.en-US.md?type=frontmatter';
import { demoIndex as dmi158 } from '/opt/buildhome/repo/packages/x/docs/spec/start.en-US.md?type=demo-index';
import { frontmatter as fm159, toc as t159 } from '/opt/buildhome/repo/packages/x/docs/spec/start.zh-CN.md?type=frontmatter';
import { demoIndex as dmi159 } from '/opt/buildhome/repo/packages/x/docs/spec/start.zh-CN.md?type=demo-index';
import { frontmatter as fm160, toc as t160 } from '/opt/buildhome/repo/packages/x/docs/react/faq.en-US.md?type=frontmatter';
import { demoIndex as dmi160 } from '/opt/buildhome/repo/packages/x/docs/react/faq.en-US.md?type=demo-index';
import { frontmatter as fm161, toc as t161 } from '/opt/buildhome/repo/packages/x/docs/react/faq.zh-CN.md?type=frontmatter';
import { demoIndex as dmi161 } from '/opt/buildhome/repo/packages/x/docs/react/faq.zh-CN.md?type=demo-index';
import { frontmatter as fm162, toc as t162 } from '/opt/buildhome/repo/packages/x/docs/spec/hint.en-US.md?type=frontmatter';
import { demoIndex as dmi162 } from '/opt/buildhome/repo/packages/x/docs/spec/hint.en-US.md?type=demo-index';
import { frontmatter as fm163, toc as t163 } from '/opt/buildhome/repo/packages/x/docs/spec/hint.zh-CN.md?type=frontmatter';
import { demoIndex as dmi163 } from '/opt/buildhome/repo/packages/x/docs/spec/hint.zh-CN.md?type=demo-index';
import { frontmatter as fm164, toc as t164 } from '/opt/buildhome/repo/packages/x/docs/spec/end.en-US.md?type=frontmatter';
import { demoIndex as dmi164 } from '/opt/buildhome/repo/packages/x/docs/spec/end.en-US.md?type=demo-index';
import { frontmatter as fm165, toc as t165 } from '/opt/buildhome/repo/packages/x/docs/spec/end.zh-CN.md?type=frontmatter';
import { demoIndex as dmi165 } from '/opt/buildhome/repo/packages/x/docs/spec/end.zh-CN.md?type=demo-index';
import { frontmatter as fm166, toc as t166 } from '/opt/buildhome/repo/packages/x/components/actions/index.en-US.md?type=frontmatter';
import { demoIndex as dmi166 } from '/opt/buildhome/repo/packages/x/components/actions/index.en-US.md?type=demo-index';
import { frontmatter as fm167, toc as t167 } from '/opt/buildhome/repo/packages/x/components/actions/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi167 } from '/opt/buildhome/repo/packages/x/components/actions/index.zh-CN.md?type=demo-index';
import { frontmatter as fm168, toc as t168 } from '/opt/buildhome/repo/packages/x/components/attachments/index.en-US.md?type=frontmatter';
import { demoIndex as dmi168 } from '/opt/buildhome/repo/packages/x/components/attachments/index.en-US.md?type=demo-index';
import { frontmatter as fm169, toc as t169 } from '/opt/buildhome/repo/packages/x/components/attachments/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi169 } from '/opt/buildhome/repo/packages/x/components/attachments/index.zh-CN.md?type=demo-index';
import { frontmatter as fm170, toc as t170 } from '/opt/buildhome/repo/packages/x/components/bubble/index.en-US.md?type=frontmatter';
import { demoIndex as dmi170 } from '/opt/buildhome/repo/packages/x/components/bubble/index.en-US.md?type=demo-index';
import { frontmatter as fm171, toc as t171 } from '/opt/buildhome/repo/packages/x/components/bubble/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi171 } from '/opt/buildhome/repo/packages/x/components/bubble/index.zh-CN.md?type=demo-index';
import { frontmatter as fm172, toc as t172 } from '/opt/buildhome/repo/packages/x/components/code-highlighter/index.en-US.md?type=frontmatter';
import { demoIndex as dmi172 } from '/opt/buildhome/repo/packages/x/components/code-highlighter/index.en-US.md?type=demo-index';
import { frontmatter as fm173, toc as t173 } from '/opt/buildhome/repo/packages/x/components/code-highlighter/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi173 } from '/opt/buildhome/repo/packages/x/components/code-highlighter/index.zh-CN.md?type=demo-index';
import { frontmatter as fm174, toc as t174 } from '/opt/buildhome/repo/packages/x/components/conversations/index.en-US.md?type=frontmatter';
import { demoIndex as dmi174 } from '/opt/buildhome/repo/packages/x/components/conversations/index.en-US.md?type=demo-index';
import { frontmatter as fm175, toc as t175 } from '/opt/buildhome/repo/packages/x/components/conversations/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi175 } from '/opt/buildhome/repo/packages/x/components/conversations/index.zh-CN.md?type=demo-index';
import { frontmatter as fm176, toc as t176 } from '/opt/buildhome/repo/packages/x/components/file-card/index.en-US.md?type=frontmatter';
import { demoIndex as dmi176 } from '/opt/buildhome/repo/packages/x/components/file-card/index.en-US.md?type=demo-index';
import { frontmatter as fm177, toc as t177 } from '/opt/buildhome/repo/packages/x/components/file-card/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi177 } from '/opt/buildhome/repo/packages/x/components/file-card/index.zh-CN.md?type=demo-index';
import { frontmatter as fm178, toc as t178 } from '/opt/buildhome/repo/packages/x/components/folder/index.en-US.md?type=frontmatter';
import { demoIndex as dmi178 } from '/opt/buildhome/repo/packages/x/components/folder/index.en-US.md?type=demo-index';
import { frontmatter as fm179, toc as t179 } from '/opt/buildhome/repo/packages/x/components/folder/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi179 } from '/opt/buildhome/repo/packages/x/components/folder/index.zh-CN.md?type=demo-index';
import { frontmatter as fm180, toc as t180 } from '/opt/buildhome/repo/packages/x/components/introduce/index.en-US.md?type=frontmatter';
import { demoIndex as dmi180 } from '/opt/buildhome/repo/packages/x/components/introduce/index.en-US.md?type=demo-index';
import { frontmatter as fm181, toc as t181 } from '/opt/buildhome/repo/packages/x/components/introduce/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi181 } from '/opt/buildhome/repo/packages/x/components/introduce/index.zh-CN.md?type=demo-index';
import { frontmatter as fm182, toc as t182 } from '/opt/buildhome/repo/packages/x/components/mermaid/index.en-US.md?type=frontmatter';
import { demoIndex as dmi182 } from '/opt/buildhome/repo/packages/x/components/mermaid/index.en-US.md?type=demo-index';
import { frontmatter as fm183, toc as t183 } from '/opt/buildhome/repo/packages/x/components/mermaid/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi183 } from '/opt/buildhome/repo/packages/x/components/mermaid/index.zh-CN.md?type=demo-index';
import { frontmatter as fm184, toc as t184 } from '/opt/buildhome/repo/packages/x/components/notification/index.en-US.md?type=frontmatter';
import { demoIndex as dmi184 } from '/opt/buildhome/repo/packages/x/components/notification/index.en-US.md?type=demo-index';
import { frontmatter as fm185, toc as t185 } from '/opt/buildhome/repo/packages/x/components/notification/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi185 } from '/opt/buildhome/repo/packages/x/components/notification/index.zh-CN.md?type=demo-index';
import { frontmatter as fm186, toc as t186 } from '/opt/buildhome/repo/packages/x/components/overview/index.en-US.md?type=frontmatter';
import { demoIndex as dmi186 } from '/opt/buildhome/repo/packages/x/components/overview/index.en-US.md?type=demo-index';
import { frontmatter as fm187, toc as t187 } from '/opt/buildhome/repo/packages/x/components/overview/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi187 } from '/opt/buildhome/repo/packages/x/components/overview/index.zh-CN.md?type=demo-index';
import { frontmatter as fm188, toc as t188 } from '/opt/buildhome/repo/packages/x/components/prompts/index.en-US.md?type=frontmatter';
import { demoIndex as dmi188 } from '/opt/buildhome/repo/packages/x/components/prompts/index.en-US.md?type=demo-index';
import { frontmatter as fm189, toc as t189 } from '/opt/buildhome/repo/packages/x/components/prompts/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi189 } from '/opt/buildhome/repo/packages/x/components/prompts/index.zh-CN.md?type=demo-index';
import { frontmatter as fm190, toc as t190 } from '/opt/buildhome/repo/packages/x/components/sender/index.en-US.md?type=frontmatter';
import { demoIndex as dmi190 } from '/opt/buildhome/repo/packages/x/components/sender/index.en-US.md?type=demo-index';
import { frontmatter as fm191, toc as t191 } from '/opt/buildhome/repo/packages/x/components/sender/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi191 } from '/opt/buildhome/repo/packages/x/components/sender/index.zh-CN.md?type=demo-index';
import { frontmatter as fm192, toc as t192 } from '/opt/buildhome/repo/packages/x/components/sources/index.en-US.md?type=frontmatter';
import { demoIndex as dmi192 } from '/opt/buildhome/repo/packages/x/components/sources/index.en-US.md?type=demo-index';
import { frontmatter as fm193, toc as t193 } from '/opt/buildhome/repo/packages/x/components/sources/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi193 } from '/opt/buildhome/repo/packages/x/components/sources/index.zh-CN.md?type=demo-index';
import { frontmatter as fm194, toc as t194 } from '/opt/buildhome/repo/packages/x/components/suggestion/index.en-US.md?type=frontmatter';
import { demoIndex as dmi194 } from '/opt/buildhome/repo/packages/x/components/suggestion/index.en-US.md?type=demo-index';
import { frontmatter as fm195, toc as t195 } from '/opt/buildhome/repo/packages/x/components/suggestion/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi195 } from '/opt/buildhome/repo/packages/x/components/suggestion/index.zh-CN.md?type=demo-index';
import { frontmatter as fm196, toc as t196 } from '/opt/buildhome/repo/packages/x/components/think/index.en-US.md?type=frontmatter';
import { demoIndex as dmi196 } from '/opt/buildhome/repo/packages/x/components/think/index.en-US.md?type=demo-index';
import { frontmatter as fm197, toc as t197 } from '/opt/buildhome/repo/packages/x/components/think/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi197 } from '/opt/buildhome/repo/packages/x/components/think/index.zh-CN.md?type=demo-index';
import { frontmatter as fm198, toc as t198 } from '/opt/buildhome/repo/packages/x/components/thought-chain/index.en-US.md?type=frontmatter';
import { demoIndex as dmi198 } from '/opt/buildhome/repo/packages/x/components/thought-chain/index.en-US.md?type=demo-index';
import { frontmatter as fm199, toc as t199 } from '/opt/buildhome/repo/packages/x/components/thought-chain/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi199 } from '/opt/buildhome/repo/packages/x/components/thought-chain/index.zh-CN.md?type=demo-index';
import { frontmatter as fm200, toc as t200 } from '/opt/buildhome/repo/packages/x/components/welcome/index.en-US.md?type=frontmatter';
import { demoIndex as dmi200 } from '/opt/buildhome/repo/packages/x/components/welcome/index.en-US.md?type=demo-index';
import { frontmatter as fm201, toc as t201 } from '/opt/buildhome/repo/packages/x/components/welcome/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi201 } from '/opt/buildhome/repo/packages/x/components/welcome/index.zh-CN.md?type=demo-index';
import { frontmatter as fm202, toc as t202 } from '/opt/buildhome/repo/packages/x/components/x-provider/index.en-US.md?type=frontmatter';
import { demoIndex as dmi202 } from '/opt/buildhome/repo/packages/x/components/x-provider/index.en-US.md?type=demo-index';
import { frontmatter as fm203, toc as t203 } from '/opt/buildhome/repo/packages/x/components/x-provider/index.zh-CN.md?type=frontmatter';
import { demoIndex as dmi203 } from '/opt/buildhome/repo/packages/x/components/x-provider/index.zh-CN.md?type=demo-index';
import { frontmatter as fm204, toc as t204 } from '/opt/buildhome/repo/CHANGELOG.zh-CN.md?type=frontmatter';
import { demoIndex as dmi204 } from '/opt/buildhome/repo/CHANGELOG.zh-CN.md?type=demo-index';
import { frontmatter as fm205, toc as t205 } from '/opt/buildhome/repo/CHANGELOG.en-US.md?type=frontmatter';
import { demoIndex as dmi205 } from '/opt/buildhome/repo/CHANGELOG.en-US.md?type=demo-index';

export const filesMeta = {
  'index/common/CustomizationProvider': {
    frontmatter: fm0,
    toc: t0,
  },
  'index/common/CustomizationSender': {
    frontmatter: fm1,
    toc: t1,
  },
  'index/common/Introduction': {
    frontmatter: fm2,
    toc: t2,
  },
  'index/common/Container': {
    frontmatter: fm3,
    toc: t3,
  },
  'index-cn/index': {
    frontmatter: fm4,
    toc: t4,
  },
  'index/index': {
    frontmatter: fm5,
    toc: t5,
  },
  'docs/x-sdk/demos/chat-providers/default-chat-provider-width-ui': {
    frontmatter: fm6,
    toc: t6,
    demoIndex: dmi6,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/default-chat-provider-width-ui.md?type=text'),
  },
  'docs/x-sdk/demos/chat-providers/custom-provider-width-ui': {
    frontmatter: fm7,
    toc: t7,
    demoIndex: dmi7,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/custom-provider-width-ui.md?type=text'),
  },
  'docs/x-sdk/demos/chat-providers/deep-seek-chat-provider': {
    frontmatter: fm8,
    toc: t8,
    demoIndex: dmi8,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/deep-seek-chat-provider.md?type=text'),
  },
  'docs/x-sdk/demos/x-conversations/async-defaultMessages': {
    frontmatter: fm9,
    toc: t9,
    demoIndex: dmi9,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/async-defaultMessages.md?type=text'),
  },
  'docs/x-sdk/demos/chat-providers/default-chat-provider': {
    frontmatter: fm10,
    toc: t10,
    demoIndex: dmi10,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/default-chat-provider.md?type=text'),
  },
  'docs/x-sdk/demos/chat-providers/open-ai-chat-provider': {
    frontmatter: fm11,
    toc: t11,
    demoIndex: dmi11,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/chat-providers/open-ai-chat-provider.md?type=text'),
  },
  'docs/x-sdk/demos/x-conversations/multi-instances': {
    frontmatter: fm12,
    toc: t12,
    demoIndex: dmi12,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/multi-instances.md?type=text'),
  },
  'docs/x-sdk/demos/x-request/custom-params-headers': {
    frontmatter: fm13,
    toc: t13,
    demoIndex: dmi13,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-params-headers.md?type=text'),
  },
  'docs/spec/provide-intention-expectation.en-US': {
    frontmatter: fm14,
    toc: t14,
    demoIndex: dmi14,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/provide-intention-expectation.en-US.md?type=text'),
  },
  'docs/spec/provide-intention-expectation.zh-CN': {
    frontmatter: fm15,
    toc: t15,
    demoIndex: dmi15,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/provide-intention-expectation.zh-CN.md?type=text'),
  },
  'docs/x-sdk/demos/x-chat/async-defaultMessages': {
    frontmatter: fm16,
    toc: t16,
    demoIndex: dmi16,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/async-defaultMessages.md?type=text'),
  },
  'docs/x-sdk/demos/x-request/custom-transformer': {
    frontmatter: fm17,
    toc: t17,
    demoIndex: dmi17,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/custom-transformer.md?type=text'),
  },
  'docs/x-sdk/demos/x-chat/custom-request-fetch': {
    frontmatter: fm18,
    toc: t18,
    demoIndex: dmi18,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/custom-request-fetch.md?type=text'),
  },
  'docs/x-sdk/demos/x-conversations/session-key': {
    frontmatter: fm19,
    toc: t19,
    demoIndex: dmi19,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/session-key.md?type=text'),
  },
  'docs/x-sdk/demos/x-conversations/with-x-chat': {
    frontmatter: fm20,
    toc: t20,
    demoIndex: dmi20,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/with-x-chat.md?type=text'),
  },
  'docs/spec/feedback-result-application.en-US': {
    frontmatter: fm21,
    toc: t21,
    demoIndex: dmi21,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/feedback-result-application.en-US.md?type=text'),
  },
  'docs/spec/feedback-result-application.zh-CN': {
    frontmatter: fm22,
    toc: t22,
    demoIndex: dmi22,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/feedback-result-application.zh-CN.md?type=text'),
  },
  'docs/x-sdk/demos/x-chat/request-openai-node': {
    frontmatter: fm23,
    toc: t23,
    demoIndex: dmi23,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/request-openai-node.md?type=text'),
  },
  'docs/x-sdk/demos/x-conversations/operations': {
    frontmatter: fm24,
    toc: t24,
    demoIndex: dmi24,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/operations.md?type=text'),
  },
  'docs/x-sdk/demos/x-request/stream-separator': {
    frontmatter: fm25,
    toc: t25,
    demoIndex: dmi25,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/stream-separator.md?type=text'),
  },
  'docs/react/use-with-create-react-app.en-US': {
    frontmatter: fm26,
    toc: t26,
    demoIndex: dmi26,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/use-with-create-react-app.en-US.md?type=text'),
  },
  'docs/react/use-with-create-react-app.zh-CN': {
    frontmatter: fm27,
    toc: t27,
    demoIndex: dmi27,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/use-with-create-react-app.zh-CN.md?type=text'),
  },
  'docs/spec/confirm-generation-process.en-US': {
    frontmatter: fm28,
    toc: t28,
    demoIndex: dmi28,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/confirm-generation-process.en-US.md?type=text'),
  },
  'docs/spec/confirm-generation-process.zh-CN': {
    frontmatter: fm29,
    toc: t29,
    demoIndex: dmi29,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/confirm-generation-process.zh-CN.md?type=text'),
  },
  'docs/spec/guide-intention-expression.en-US': {
    frontmatter: fm30,
    toc: t30,
    demoIndex: dmi30,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/guide-intention-expression.en-US.md?type=text'),
  },
  'docs/spec/guide-intention-expression.zh-CN': {
    frontmatter: fm31,
    toc: t31,
    demoIndex: dmi31,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/guide-intention-expression.zh-CN.md?type=text'),
  },
  'docs/x-sdk/demos/x-stream/default-protocol': {
    frontmatter: fm32,
    toc: t32,
    demoIndex: dmi32,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-stream/default-protocol.md?type=text'),
  },
  'docs/x-sdk/demos/x-request/stream-timeout': {
    frontmatter: fm33,
    toc: t33,
    demoIndex: dmi33,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/stream-timeout.md?type=text'),
  },
  'docs/x-sdk/demos/x-stream/custom-protocol': {
    frontmatter: fm34,
    toc: t34,
    demoIndex: dmi34,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-stream/custom-protocol.md?type=text'),
  },
  'docs/spec/feedback-result-display.en-US': {
    frontmatter: fm35,
    toc: t35,
    demoIndex: dmi35,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/feedback-result-display.en-US.md?type=text'),
  },
  'docs/spec/feedback-result-display.zh-CN': {
    frontmatter: fm36,
    toc: t36,
    demoIndex: dmi36,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/feedback-result-display.zh-CN.md?type=text'),
  },
  'docs/spec/wake-up-welcome-message.en-US': {
    frontmatter: fm37,
    toc: t37,
    demoIndex: dmi37,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/wake-up-welcome-message.en-US.md?type=text'),
  },
  'docs/spec/wake-up-welcome-message.zh-CN': {
    frontmatter: fm38,
    toc: t38,
    demoIndex: dmi38,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/wake-up-welcome-message.zh-CN.md?type=text'),
  },
  'docs/x-sdk/chat-provider-deepseek.en-US': {
    frontmatter: fm39,
    toc: t39,
    demoIndex: dmi39,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-deepseek.en-US.md?type=text'),
  },
  'docs/x-sdk/chat-provider-deepseek.zh-CN': {
    frontmatter: fm40,
    toc: t40,
    demoIndex: dmi40,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-deepseek.zh-CN.md?type=text'),
  },
  'docs/x-sdk/demos/x-chat/defaultMessages': {
    frontmatter: fm41,
    toc: t41,
    demoIndex: dmi41,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/defaultMessages.md?type=text'),
  },
  'docs/x-sdk/demos/x-chat/openai-callback': {
    frontmatter: fm42,
    toc: t42,
    demoIndex: dmi42,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/openai-callback.md?type=text'),
  },
  'docs/x-markdown/chat-enhancement.en-US': {
    frontmatter: fm43,
    toc: t43,
    demoIndex: dmi43,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.en-US.md?type=text'),
  },
  'docs/x-markdown/chat-enhancement.zh-CN': {
    frontmatter: fm44,
    toc: t44,
    demoIndex: dmi44,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.zh-CN.md?type=text'),
  },
  'docs/x-sdk/chat-provider-open-ai.en-US': {
    frontmatter: fm45,
    toc: t45,
    demoIndex: dmi45,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.en-US.md?type=text'),
  },
  'docs/x-sdk/chat-provider-open-ai.zh-CN': {
    frontmatter: fm46,
    toc: t46,
    demoIndex: dmi46,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-open-ai.zh-CN.md?type=text'),
  },
  'docs/x-sdk/demos/x-conversations/basic': {
    frontmatter: fm47,
    toc: t47,
    demoIndex: dmi47,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/basic.md?type=text'),
  },
  'docs/spec/define-intention-type.en-US': {
    frontmatter: fm48,
    toc: t48,
    demoIndex: dmi48,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/define-intention-type.en-US.md?type=text'),
  },
  'docs/spec/define-intention-type.zh-CN': {
    frontmatter: fm49,
    toc: t49,
    demoIndex: dmi49,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/define-intention-type.zh-CN.md?type=text'),
  },
  'docs/spec/expression-user-input.en-US': {
    frontmatter: fm50,
    toc: t50,
    demoIndex: dmi50,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/expression-user-input.en-US.md?type=text'),
  },
  'docs/spec/expression-user-input.zh-CN': {
    frontmatter: fm51,
    toc: t51,
    demoIndex: dmi51,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/expression-user-input.zh-CN.md?type=text'),
  },
  'docs/x-sdk/chat-provider-custom.en-US': {
    frontmatter: fm52,
    toc: t52,
    demoIndex: dmi52,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.en-US.md?type=text'),
  },
  'docs/x-sdk/chat-provider-custom.zh-CN': {
    frontmatter: fm53,
    toc: t53,
    demoIndex: dmi53,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider-custom.zh-CN.md?type=text'),
  },
  'docs/spec/authentic-consistent.en-US': {
    frontmatter: fm54,
    toc: t54,
    demoIndex: dmi54,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/authentic-consistent.en-US.md?type=text'),
  },
  'docs/spec/authentic-consistent.zh-CN': {
    frontmatter: fm55,
    toc: t55,
    demoIndex: dmi55,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/authentic-consistent.zh-CN.md?type=text'),
  },
  'docs/spec/expression-user-send.en-US': {
    frontmatter: fm56,
    toc: t56,
    demoIndex: dmi56,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/expression-user-send.en-US.md?type=text'),
  },
  'docs/spec/expression-user-send.zh-CN': {
    frontmatter: fm57,
    toc: t57,
    demoIndex: dmi57,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/expression-user-send.zh-CN.md?type=text'),
  },
  'docs/x-sdk/use-x-conversations.en-US': {
    frontmatter: fm58,
    toc: t58,
    demoIndex: dmi58,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-conversations.en-US.md?type=text'),
  },
  'docs/x-sdk/use-x-conversations.zh-CN': {
    frontmatter: fm59,
    toc: t59,
    demoIndex: dmi59,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-conversations.zh-CN.md?type=text'),
  },
  'docs/spec/conversation-design.en-US': {
    frontmatter: fm60,
    toc: t60,
    demoIndex: dmi60,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/conversation-design.en-US.md?type=text'),
  },
  'docs/spec/conversation-design.zh-CN': {
    frontmatter: fm61,
    toc: t61,
    demoIndex: dmi61,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/conversation-design.zh-CN.md?type=text'),
  },
  'docs/spec/intention-introduce.en-US': {
    frontmatter: fm62,
    toc: t62,
    demoIndex: dmi62,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/intention-introduce.en-US.md?type=text'),
  },
  'docs/spec/intention-introduce.zh-CN': {
    frontmatter: fm63,
    toc: t63,
    demoIndex: dmi63,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/intention-introduce.zh-CN.md?type=text'),
  },
  'docs/x-markdown/custom-plugin.en-US': {
    frontmatter: fm64,
    toc: t64,
    demoIndex: dmi64,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.en-US.md?type=text'),
  },
  'docs/x-markdown/custom-plugin.zh-CN': {
    frontmatter: fm65,
    toc: t65,
    demoIndex: dmi65,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.zh-CN.md?type=text'),
  },
  'docs/x-markdown/data-display.en-US': {
    frontmatter: fm66,
    toc: t66,
    demoIndex: dmi66,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.en-US.md?type=text'),
  },
  'docs/x-markdown/data-display.zh-CN': {
    frontmatter: fm67,
    toc: t67,
    demoIndex: dmi67,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/data-display.zh-CN.md?type=text'),
  },
  'docs/x-markdown/plugin-latex.en-US': {
    frontmatter: fm68,
    toc: t68,
    demoIndex: dmi68,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.en-US.md?type=text'),
  },
  'docs/x-markdown/plugin-latex.zh-CN': {
    frontmatter: fm69,
    toc: t69,
    demoIndex: dmi69,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-latex.zh-CN.md?type=text'),
  },
  'docs/x-sdk/demos/x-request/timeout': {
    frontmatter: fm70,
    toc: t70,
    demoIndex: dmi70,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/timeout.md?type=text'),
  },
  'docs/playground/independent.en-US': {
    frontmatter: fm71,
    toc: t71,
    demoIndex: dmi71,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/playground/independent.en-US.md?type=text'),
  },
  'docs/playground/independent.zh-CN': {
    frontmatter: fm72,
    toc: t72,
    demoIndex: dmi72,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/playground/independent.zh-CN.md?type=text'),
  },
  'docs/playground/ultramodern.en-US': {
    frontmatter: fm73,
    toc: t73,
    demoIndex: dmi73,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/playground/ultramodern.en-US.md?type=text'),
  },
  'docs/playground/ultramodern.zh-CN': {
    frontmatter: fm74,
    toc: t74,
    demoIndex: dmi74,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/playground/ultramodern.zh-CN.md?type=text'),
  },
  'docs/react/compatible-style.en-US': {
    frontmatter: fm75,
    toc: t75,
    demoIndex: dmi75,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/compatible-style.en-US.md?type=text'),
  },
  'docs/react/compatible-style.zh-CN': {
    frontmatter: fm76,
    toc: t76,
    demoIndex: dmi76,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/compatible-style.zh-CN.md?type=text'),
  },
  'docs/react/model-use-openai.en-US': {
    frontmatter: fm77,
    toc: t77,
    demoIndex: dmi77,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/model-use-openai.en-US.md?type=text'),
  },
  'docs/react/model-use-openai.zh-CN': {
    frontmatter: fm78,
    toc: t78,
    demoIndex: dmi78,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/model-use-openai.zh-CN.md?type=text'),
  },
  'docs/react/use-with-rsbuild.en-US': {
    frontmatter: fm79,
    toc: t79,
    demoIndex: dmi79,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/use-with-rsbuild.en-US.md?type=text'),
  },
  'docs/react/use-with-rsbuild.zh-CN': {
    frontmatter: fm80,
    toc: t80,
    demoIndex: dmi80,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/use-with-rsbuild.zh-CN.md?type=text'),
  },
  'docs/x-sdk/demos/x-chat/developer': {
    frontmatter: fm81,
    toc: t81,
    demoIndex: dmi81,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/developer.md?type=text'),
  },
  'docs/x-sdk/demos/x-request/manual': {
    frontmatter: fm82,
    toc: t82,
    demoIndex: dmi82,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/manual.md?type=text'),
  },
  'docs/playground/agent-tbox.en-US': {
    frontmatter: fm83,
    toc: t83,
    demoIndex: dmi83,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.en-US.md?type=text'),
  },
  'docs/playground/agent-tbox.zh-CN': {
    frontmatter: fm84,
    toc: t84,
    demoIndex: dmi84,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/playground/agent-tbox.zh-CN.md?type=text'),
  },
  'docs/spec/hybrid-ui-design.en-US': {
    frontmatter: fm85,
    toc: t85,
    demoIndex: dmi85,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/hybrid-ui-design.en-US.md?type=text'),
  },
  'docs/spec/hybrid-ui-design.zh-CN': {
    frontmatter: fm86,
    toc: t86,
    demoIndex: dmi86,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/hybrid-ui-design.zh-CN.md?type=text'),
  },
  'docs/x-markdown/components.en-US': {
    frontmatter: fm87,
    toc: t87,
    demoIndex: dmi87,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components.en-US.md?type=text'),
  },
  'docs/x-markdown/components.zh-CN': {
    frontmatter: fm88,
    toc: t88,
    demoIndex: dmi88,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components.zh-CN.md?type=text'),
  },
  'docs/x-markdown/playground.en-US': {
    frontmatter: fm89,
    toc: t89,
    demoIndex: dmi89,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/playground.en-US.md?type=text'),
  },
  'docs/x-markdown/playground.zh-CN': {
    frontmatter: fm90,
    toc: t90,
    demoIndex: dmi90,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/playground.zh-CN.md?type=text'),
  },
  'docs/x-sdk/demos/x-chat/deepSeek': {
    frontmatter: fm91,
    toc: t91,
    demoIndex: dmi91,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/deepSeek.md?type=text'),
  },
  'docs/x-sdk/demos/x-request/basic': {
    frontmatter: fm92,
    toc: t92,
    demoIndex: dmi92,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/basic.md?type=text'),
  },
  'docs/react/agent-use-tbox.en-US': {
    frontmatter: fm93,
    toc: t93,
    demoIndex: dmi93,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.en-US.md?type=text'),
  },
  'docs/react/agent-use-tbox.zh-CN': {
    frontmatter: fm94,
    toc: t94,
    demoIndex: dmi94,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/agent-use-tbox.zh-CN.md?type=text'),
  },
  'docs/react/model-use-qwen.en-US': {
    frontmatter: fm95,
    toc: t95,
    demoIndex: dmi95,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.en-US.md?type=text'),
  },
  'docs/react/model-use-qwen.zh-CN': {
    frontmatter: fm96,
    toc: t96,
    demoIndex: dmi96,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.zh-CN.md?type=text'),
  },
  'docs/spec/wake-up-ai-icon.en-US': {
    frontmatter: fm97,
    toc: t97,
    demoIndex: dmi97,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/wake-up-ai-icon.en-US.md?type=text'),
  },
  'docs/spec/wake-up-ai-icon.zh-CN': {
    frontmatter: fm98,
    toc: t98,
    demoIndex: dmi98,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/wake-up-ai-icon.zh-CN.md?type=text'),
  },
  'docs/x-markdown/introduce.en-US': {
    frontmatter: fm99,
    toc: t99,
    demoIndex: dmi99,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/introduce.en-US.md?type=text'),
  },
  'docs/x-markdown/introduce.zh-CN': {
    frontmatter: fm100,
    toc: t100,
    demoIndex: dmi100,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/introduce.zh-CN.md?type=text'),
  },
  'docs/x-markdown/rich-text.en-US': {
    frontmatter: fm101,
    toc: t101,
    demoIndex: dmi101,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.en-US.md?type=text'),
  },
  'docs/x-markdown/rich-text.zh-CN': {
    frontmatter: fm102,
    toc: t102,
    demoIndex: dmi102,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.zh-CN.md?type=text'),
  },
  'docs/x-markdown/streaming.en-US': {
    frontmatter: fm103,
    toc: t103,
    demoIndex: dmi103,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.en-US.md?type=text'),
  },
  'docs/x-markdown/streaming.zh-CN': {
    frontmatter: fm104,
    toc: t104,
    demoIndex: dmi104,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/streaming.zh-CN.md?type=text'),
  },
  'docs/react/use-with-next.en-US': {
    frontmatter: fm105,
    toc: t105,
    demoIndex: dmi105,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/use-with-next.en-US.md?type=text'),
  },
  'docs/react/use-with-next.zh-CN': {
    frontmatter: fm106,
    toc: t106,
    demoIndex: dmi106,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/use-with-next.zh-CN.md?type=text'),
  },
  'docs/react/use-with-vite.en-US': {
    frontmatter: fm107,
    toc: t107,
    demoIndex: dmi107,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/use-with-vite.en-US.md?type=text'),
  },
  'docs/react/use-with-vite.zh-CN': {
    frontmatter: fm108,
    toc: t108,
    demoIndex: dmi108,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/use-with-vite.zh-CN.md?type=text'),
  },
  'docs/spec/smooth-natural.en-US': {
    frontmatter: fm109,
    toc: t109,
    demoIndex: dmi109,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/smooth-natural.en-US.md?type=text'),
  },
  'docs/spec/smooth-natural.zh-CN': {
    frontmatter: fm110,
    toc: t110,
    demoIndex: dmi110,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/smooth-natural.zh-CN.md?type=text'),
  },
  'docs/x-markdown/examples.en-US': {
    frontmatter: fm111,
    toc: t111,
    demoIndex: dmi111,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/examples.en-US.md?type=text'),
  },
  'docs/x-markdown/examples.zh-CN': {
    frontmatter: fm112,
    toc: t112,
    demoIndex: dmi112,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/examples.zh-CN.md?type=text'),
  },
  'docs/x-sdk/chat-provider.en-US': {
    frontmatter: fm113,
    toc: t113,
    demoIndex: dmi113,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.en-US.md?type=text'),
  },
  'docs/x-sdk/chat-provider.zh-CN': {
    frontmatter: fm114,
    toc: t114,
    demoIndex: dmi114,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.zh-CN.md?type=text'),
  },
  'docs/x-sdk/demos/x-chat/openai': {
    frontmatter: fm115,
    toc: t115,
    demoIndex: dmi115,
    textGetter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-chat/openai.md?type=text'),
  },
  'docs/playground/copilot.en-US': {
    frontmatter: fm116,
    toc: t116,
    demoIndex: dmi116,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/playground/copilot.en-US.md?type=text'),
  },
  'docs/playground/copilot.zh-CN': {
    frontmatter: fm117,
    toc: t117,
    demoIndex: dmi117,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/playground/copilot.zh-CN.md?type=text'),
  },
  'docs/react/common-props.en-US': {
    frontmatter: fm118,
    toc: t118,
    demoIndex: dmi118,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/common-props.en-US.md?type=text'),
  },
  'docs/react/common-props.zh-CN': {
    frontmatter: fm119,
    toc: t119,
    demoIndex: dmi119,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/common-props.zh-CN.md?type=text'),
  },
  'docs/react/contributing.en-US': {
    frontmatter: fm120,
    toc: t120,
    demoIndex: dmi120,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/contributing.en-US.md?type=text'),
  },
  'docs/react/contributing.zh-CN': {
    frontmatter: fm121,
    toc: t121,
    demoIndex: dmi121,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/contributing.zh-CN.md?type=text'),
  },
  'docs/react/migration-v2.en-US': {
    frontmatter: fm122,
    toc: t122,
    demoIndex: dmi122,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/migration-v2.en-US.md?type=text'),
  },
  'docs/react/migration-v2.zh-CN': {
    frontmatter: fm123,
    toc: t123,
    demoIndex: dmi123,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/migration-v2.zh-CN.md?type=text'),
  },
  'docs/react/use-with-umi.en-US': {
    frontmatter: fm124,
    toc: t124,
    demoIndex: dmi124,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/use-with-umi.en-US.md?type=text'),
  },
  'docs/react/use-with-umi.zh-CN': {
    frontmatter: fm125,
    toc: t125,
    demoIndex: dmi125,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/use-with-umi.zh-CN.md?type=text'),
  },
  'docs/x-markdown/plugins.en-US': {
    frontmatter: fm126,
    toc: t126,
    demoIndex: dmi126,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugins.en-US.md?type=text'),
  },
  'docs/x-markdown/plugins.zh-CN': {
    frontmatter: fm127,
    toc: t127,
    demoIndex: dmi127,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugins.zh-CN.md?type=text'),
  },
  'docs/x-markdown/themes.en-US': {
    frontmatter: fm128,
    toc: t128,
    demoIndex: dmi128,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/themes.en-US.md?type=text'),
  },
  'docs/x-markdown/themes.zh-CN': {
    frontmatter: fm129,
    toc: t129,
    demoIndex: dmi129,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/themes.zh-CN.md?type=text'),
  },
  'docs/x-skill/introduce.en-US': {
    frontmatter: fm130,
    toc: t130,
    demoIndex: dmi130,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-skill/introduce.en-US.md?type=text'),
  },
  'docs/x-skill/introduce.zh-CN': {
    frontmatter: fm131,
    toc: t131,
    demoIndex: dmi131,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-skill/introduce.zh-CN.md?type=text'),
  },
  'docs/spec/human-touch.en-US': {
    frontmatter: fm132,
    toc: t132,
    demoIndex: dmi132,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/human-touch.en-US.md?type=text'),
  },
  'docs/spec/human-touch.zh-CN': {
    frontmatter: fm133,
    toc: t133,
    demoIndex: dmi133,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/human-touch.zh-CN.md?type=text'),
  },
  'docs/spec/role-design.en-US': {
    frontmatter: fm134,
    toc: t134,
    demoIndex: dmi134,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/role-design.en-US.md?type=text'),
  },
  'docs/spec/role-design.zh-CN': {
    frontmatter: fm135,
    toc: t135,
    demoIndex: dmi135,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/role-design.zh-CN.md?type=text'),
  },
  'docs/x-sdk/use-x-chat.en-US': {
    frontmatter: fm136,
    toc: t136,
    demoIndex: dmi136,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.en-US.md?type=text'),
  },
  'docs/x-sdk/use-x-chat.zh-CN': {
    frontmatter: fm137,
    toc: t137,
    demoIndex: dmi137,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.zh-CN.md?type=text'),
  },
  'docs/react/introduce.en-US': {
    frontmatter: fm138,
    toc: t138,
    demoIndex: dmi138,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/introduce.en-US.md?type=text'),
  },
  'docs/react/introduce.zh-CN': {
    frontmatter: fm139,
    toc: t139,
    demoIndex: dmi139,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/introduce.zh-CN.md?type=text'),
  },
  'docs/x-sdk/introduce.en-US': {
    frontmatter: fm140,
    toc: t140,
    demoIndex: dmi140,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/introduce.en-US.md?type=text'),
  },
  'docs/x-sdk/introduce.zh-CN': {
    frontmatter: fm141,
    toc: t141,
    demoIndex: dmi141,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/introduce.zh-CN.md?type=text'),
  },
  'docs/x-sdk/x-request.en-US': {
    frontmatter: fm142,
    toc: t142,
    demoIndex: dmi142,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.en-US.md?type=text'),
  },
  'docs/x-sdk/x-request.zh-CN': {
    frontmatter: fm143,
    toc: t143,
    demoIndex: dmi143,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/x-request.zh-CN.md?type=text'),
  },
  'docs/spec/follow-up.en-US': {
    frontmatter: fm144,
    toc: t144,
    demoIndex: dmi144,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/follow-up.en-US.md?type=text'),
  },
  'docs/spec/follow-up.zh-CN': {
    frontmatter: fm145,
    toc: t145,
    demoIndex: dmi145,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/follow-up.zh-CN.md?type=text'),
  },
  'docs/spec/introduce.en-US': {
    frontmatter: fm146,
    toc: t146,
    demoIndex: dmi146,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/introduce.en-US.md?type=text'),
  },
  'docs/spec/introduce.zh-CN': {
    frontmatter: fm147,
    toc: t147,
    demoIndex: dmi147,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/introduce.zh-CN.md?type=text'),
  },
  'docs/x-sdk/x-stream.en-US': {
    frontmatter: fm148,
    toc: t148,
    demoIndex: dmi148,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.en-US.md?type=text'),
  },
  'docs/x-sdk/x-stream.zh-CN': {
    frontmatter: fm149,
    toc: t149,
    demoIndex: dmi149,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.zh-CN.md?type=text'),
  },
  'docs/x-skill/prompt.en-US': {
    frontmatter: fm150,
    toc: t150,
    demoIndex: dmi150,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-skill/prompt.en-US.md?type=text'),
  },
  'docs/x-skill/prompt.zh-CN': {
    frontmatter: fm151,
    toc: t151,
    demoIndex: dmi151,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-skill/prompt.zh-CN.md?type=text'),
  },
  'docs/x-skill/skills.en-US': {
    frontmatter: fm152,
    toc: t152,
    demoIndex: dmi152,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-skill/skills.en-US.md?type=text'),
  },
  'docs/x-skill/skills.zh-CN': {
    frontmatter: fm153,
    toc: t153,
    demoIndex: dmi153,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-skill/skills.zh-CN.md?type=text'),
  },
  'docs/spec/confirm.en-US': {
    frontmatter: fm154,
    toc: t154,
    demoIndex: dmi154,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/confirm.en-US.md?type=text'),
  },
  'docs/spec/confirm.zh-CN': {
    frontmatter: fm155,
    toc: t155,
    demoIndex: dmi155,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/confirm.zh-CN.md?type=text'),
  },
  'docs/spec/error.en-US': {
    frontmatter: fm156,
    toc: t156,
    demoIndex: dmi156,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/error.en-US.md?type=text'),
  },
  'docs/spec/error.zh-CN': {
    frontmatter: fm157,
    toc: t157,
    demoIndex: dmi157,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/error.zh-CN.md?type=text'),
  },
  'docs/spec/start.en-US': {
    frontmatter: fm158,
    toc: t158,
    demoIndex: dmi158,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/start.en-US.md?type=text'),
  },
  'docs/spec/start.zh-CN': {
    frontmatter: fm159,
    toc: t159,
    demoIndex: dmi159,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/start.zh-CN.md?type=text'),
  },
  'docs/react/faq.en-US': {
    frontmatter: fm160,
    toc: t160,
    demoIndex: dmi160,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/faq.en-US.md?type=text'),
  },
  'docs/react/faq.zh-CN': {
    frontmatter: fm161,
    toc: t161,
    demoIndex: dmi161,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/react/faq.zh-CN.md?type=text'),
  },
  'docs/spec/hint.en-US': {
    frontmatter: fm162,
    toc: t162,
    demoIndex: dmi162,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/hint.en-US.md?type=text'),
  },
  'docs/spec/hint.zh-CN': {
    frontmatter: fm163,
    toc: t163,
    demoIndex: dmi163,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/hint.zh-CN.md?type=text'),
  },
  'docs/spec/end.en-US': {
    frontmatter: fm164,
    toc: t164,
    demoIndex: dmi164,
    textGetter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/spec/end.en-US.md?type=text'),
  },
  'docs/spec/end.zh-CN': {
    frontmatter: fm165,
    toc: t165,
    demoIndex: dmi165,
    textGetter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/spec/end.zh-CN.md?type=text'),
  },
  'components/actions/index.en-US': {
    frontmatter: fm166,
    toc: t166,
    demoIndex: dmi166,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/actions/index.en-US.md?type=text'),
  },
  'components/actions/index.zh-CN': {
    frontmatter: fm167,
    toc: t167,
    demoIndex: dmi167,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/actions/index.zh-CN.md?type=text'),
  },
  'components/attachments/index.en-US': {
    frontmatter: fm168,
    toc: t168,
    demoIndex: dmi168,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/attachments/index.en-US.md?type=text'),
  },
  'components/attachments/index.zh-CN': {
    frontmatter: fm169,
    toc: t169,
    demoIndex: dmi169,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/attachments/index.zh-CN.md?type=text'),
  },
  'components/bubble/index.en-US': {
    frontmatter: fm170,
    toc: t170,
    demoIndex: dmi170,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/bubble/index.en-US.md?type=text'),
  },
  'components/bubble/index.zh-CN': {
    frontmatter: fm171,
    toc: t171,
    demoIndex: dmi171,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/bubble/index.zh-CN.md?type=text'),
  },
  'components/code-highlighter/index.en-US': {
    frontmatter: fm172,
    toc: t172,
    demoIndex: dmi172,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/code-highlighter/index.en-US.md?type=text'),
  },
  'components/code-highlighter/index.zh-CN': {
    frontmatter: fm173,
    toc: t173,
    demoIndex: dmi173,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/code-highlighter/index.zh-CN.md?type=text'),
  },
  'components/conversations/index.en-US': {
    frontmatter: fm174,
    toc: t174,
    demoIndex: dmi174,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/conversations/index.en-US.md?type=text'),
  },
  'components/conversations/index.zh-CN': {
    frontmatter: fm175,
    toc: t175,
    demoIndex: dmi175,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/conversations/index.zh-CN.md?type=text'),
  },
  'components/file-card/index.en-US': {
    frontmatter: fm176,
    toc: t176,
    demoIndex: dmi176,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/file-card/index.en-US.md?type=text'),
  },
  'components/file-card/index.zh-CN': {
    frontmatter: fm177,
    toc: t177,
    demoIndex: dmi177,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/file-card/index.zh-CN.md?type=text'),
  },
  'components/folder/index.en-US': {
    frontmatter: fm178,
    toc: t178,
    demoIndex: dmi178,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/folder/index.en-US.md?type=text'),
  },
  'components/folder/index.zh-CN': {
    frontmatter: fm179,
    toc: t179,
    demoIndex: dmi179,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/folder/index.zh-CN.md?type=text'),
  },
  'components/introduce/index.en-US': {
    frontmatter: fm180,
    toc: t180,
    demoIndex: dmi180,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/introduce/index.en-US.md?type=text'),
  },
  'components/introduce/index.zh-CN': {
    frontmatter: fm181,
    toc: t181,
    demoIndex: dmi181,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/introduce/index.zh-CN.md?type=text'),
  },
  'components/mermaid/index.en-US': {
    frontmatter: fm182,
    toc: t182,
    demoIndex: dmi182,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/mermaid/index.en-US.md?type=text'),
  },
  'components/mermaid/index.zh-CN': {
    frontmatter: fm183,
    toc: t183,
    demoIndex: dmi183,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/mermaid/index.zh-CN.md?type=text'),
  },
  'components/notification/index.en-US': {
    frontmatter: fm184,
    toc: t184,
    demoIndex: dmi184,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/notification/index.en-US.md?type=text'),
  },
  'components/notification/index.zh-CN': {
    frontmatter: fm185,
    toc: t185,
    demoIndex: dmi185,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/notification/index.zh-CN.md?type=text'),
  },
  'components/overview/index.en-US': {
    frontmatter: fm186,
    toc: t186,
    demoIndex: dmi186,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/overview/index.en-US.md?type=text'),
  },
  'components/overview/index.zh-CN': {
    frontmatter: fm187,
    toc: t187,
    demoIndex: dmi187,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/overview/index.zh-CN.md?type=text'),
  },
  'components/prompts/index.en-US': {
    frontmatter: fm188,
    toc: t188,
    demoIndex: dmi188,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/prompts/index.en-US.md?type=text'),
  },
  'components/prompts/index.zh-CN': {
    frontmatter: fm189,
    toc: t189,
    demoIndex: dmi189,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/prompts/index.zh-CN.md?type=text'),
  },
  'components/sender/index.en-US': {
    frontmatter: fm190,
    toc: t190,
    demoIndex: dmi190,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/sender/index.en-US.md?type=text'),
  },
  'components/sender/index.zh-CN': {
    frontmatter: fm191,
    toc: t191,
    demoIndex: dmi191,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/sender/index.zh-CN.md?type=text'),
  },
  'components/sources/index.en-US': {
    frontmatter: fm192,
    toc: t192,
    demoIndex: dmi192,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/sources/index.en-US.md?type=text'),
  },
  'components/sources/index.zh-CN': {
    frontmatter: fm193,
    toc: t193,
    demoIndex: dmi193,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/sources/index.zh-CN.md?type=text'),
  },
  'components/suggestion/index.en-US': {
    frontmatter: fm194,
    toc: t194,
    demoIndex: dmi194,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/suggestion/index.en-US.md?type=text'),
  },
  'components/suggestion/index.zh-CN': {
    frontmatter: fm195,
    toc: t195,
    demoIndex: dmi195,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/suggestion/index.zh-CN.md?type=text'),
  },
  'components/think/index.en-US': {
    frontmatter: fm196,
    toc: t196,
    demoIndex: dmi196,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/think/index.en-US.md?type=text'),
  },
  'components/think/index.zh-CN': {
    frontmatter: fm197,
    toc: t197,
    demoIndex: dmi197,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/think/index.zh-CN.md?type=text'),
  },
  'components/thought-chain/index.en-US': {
    frontmatter: fm198,
    toc: t198,
    demoIndex: dmi198,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/thought-chain/index.en-US.md?type=text'),
  },
  'components/thought-chain/index.zh-CN': {
    frontmatter: fm199,
    toc: t199,
    demoIndex: dmi199,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/thought-chain/index.zh-CN.md?type=text'),
  },
  'components/welcome/index.en-US': {
    frontmatter: fm200,
    toc: t200,
    demoIndex: dmi200,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/welcome/index.en-US.md?type=text'),
  },
  'components/welcome/index.zh-CN': {
    frontmatter: fm201,
    toc: t201,
    demoIndex: dmi201,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/welcome/index.zh-CN.md?type=text'),
  },
  'components/x-provider/index.en-US': {
    frontmatter: fm202,
    toc: t202,
    demoIndex: dmi202,
    textGetter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/x-provider/index.en-US.md?type=text'),
  },
  'components/x-provider/index.zh-CN': {
    frontmatter: fm203,
    toc: t203,
    demoIndex: dmi203,
    textGetter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/packages/x/components/x-provider/index.zh-CN.md?type=text'),
  },
  'changelog-cn': {
    frontmatter: fm204,
    toc: t204,
    demoIndex: dmi204,
    textGetter: () => import(/* webpackChunkName: "meta____zh-CN" */'/opt/buildhome/repo/CHANGELOG.zh-CN.md?type=text'),
  },
  'changelog': {
    frontmatter: fm205,
    toc: t205,
    demoIndex: dmi205,
    textGetter: () => import(/* webpackChunkName: "meta____en-US" */'/opt/buildhome/repo/CHANGELOG.en-US.md?type=text'),
  },
}

export { tabs as tabsMeta } from './tabs';
